import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'signin-hcaptcha_user_wait-timing';

/**
 * Keep track of how long the user had to wait for hCaptcha to response
 */
export function trackSigninHcaptchaUserWaitTiming(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}

/**
 * Trace for event: signin-hcaptcha_user_wait-timing
 */
export function trackSigninHcaptchaUserWaitTimingTraceDataRequested(
  sourceEventMarker?: ITraceEventMarker
): void {
  trackClientEvent({
    eventKey: 'signin-hcaptcha_user_wait-timing-trace-data_requested',
    realTimeTracking: true,
    sourceEventKey: 'signin-hcaptcha_user_wait-timing',
    sourceEventMarker,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}

/**
 * Trace for event: signin-hcaptcha_user_wait-timing
 */
export function trackSigninHcaptchaUserWaitTimingTraceDataRetrieved(
  sourceEventMarker?: ITraceEventMarker
): void {
  trackClientEvent({
    eventKey: 'signin-hcaptcha_user_wait-timing-trace-data_retrieved',
    realTimeTracking: true,
    sourceEventKey: 'signin-hcaptcha_user_wait-timing',
    sourceEventMarker,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}

/**
 * Trace for event: signin-hcaptcha_user_wait-timing
 */
export function trackSigninHcaptchaUserWaitTimingTraceRetreiveFailed(
  sourceEventMarker?: ITraceEventMarker
): void {
  trackClientEvent({
    eventKey: 'signin-hcaptcha_user_wait-timing-trace-retreive_failed',
    realTimeTracking: true,
    sourceEventKey: 'signin-hcaptcha_user_wait-timing',
    sourceEventMarker,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}
